import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import { ProtectedRoute } from '../helpers/ProtectedRoute';
import Support from '../components/root/support/Support';

const SupportRoutes = ({ match: { url } }) => 
  <Switch>
    <ProtectedRoute exact path={`${url}`} rols={['manager']} component={Support} />
    <Redirect exact from={`${url}/create`} to={`${url}`} />
    <Redirect exact from={`${url}/:id`} to={`${url}`} />
    <Redirect to="/errors/404" />
  </Switch>

SupportRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(SupportRoutes);